import { render, staticRenderFns } from "./ModalSelectSale.vue?vue&type=template&id=0b3d8cd2&scoped=true"
import script from "./ModalSelectSale.vue?vue&type=script&lang=js"
export * from "./ModalSelectSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3d8cd2",
  null
  
)

export default component.exports